import { NavItem } from './nav-item.model';

export const APP_NAV_ITEMS: NavItem[] = [
  {
    label: 'Home',
    route: '/home',
    roles: ['admin', 'dekalb', 'partner'],
  },
  {
    label: 'Reports',
    route: '/reports',
    roles: ['admin', 'dekalb'],
  },
  {
    label: 'Partners',
    route: '/partners',
    roles: ['admin', 'dekalb'],
  },
  {
    label: 'Services',
    route: '/services',
    roles: ['admin', 'dekalb'],
  },
  {
    label: 'Users',
    route: '/users',
    roles: ['admin'],
  },
  // temporarily removed - only used for development/testing currently
  // {
  //   label: 'Audit Log',
  //   route: '/audit-log',
  //   roles: ['admin'],
  // },
];